// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var DayPeriods;
(function (DayPeriods) {
    DayPeriods[DayPeriods["PRE_OPEN"] = 0] = "PRE_OPEN";
    DayPeriods[DayPeriods["MAIN"] = 1] = "MAIN";
    DayPeriods[DayPeriods["POST_CLOSE"] = 2] = "POST_CLOSE";
    DayPeriods[DayPeriods["BEFORE_MARKET"] = 3] = "BEFORE_MARKET";
    DayPeriods[DayPeriods["AFTER_MARKET"] = 4] = "AFTER_MARKET";
})(DayPeriods || (DayPeriods = {}));
